import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconOrdersAdd = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 65 92">
    <path fill={theme.palette.primary[150]} d="m48.75 9v8.1374c0 0.97644-0.65002 1.6274-1.625 1.6274h-29.25c-0.97511 0-1.625-0.81372-1.625-1.6274v-8.137h-9.75c-3.5751 0-6.5 2.929-6.5 6.51v69.98c0 3.581 2.9249 6.51 6.5 6.51h52c3.575 0 6.5-2.929 6.5-6.51v-69.98c0-3.581-2.925-6.51-6.5-6.51h-9.7498z" />
    <path fill={theme.palette.primary[500]} d="m41.5 6.1538v-3.0769c0-1.6924-1.53-3.0769-3.4-3.0769h-10.2c-1.87 0-3.4 1.3845-3.4 3.0769v3.0769h-6.8001c-1.02 0-1.7 0.6154-1.7 1.5385v10.77c0 0.923 0.68 1.538 1.7 1.538h30.6c1.02 0 1.7-0.615 1.7-1.538v-10.77c0-0.9228-0.68-1.5382-1.7-1.5382h-6.7998z" />
    <path fill={theme.palette.primary[500]} d="m52 56.5c0-10.725-8.775-19.5-19.5-19.5s-19.5 8.775-19.5 19.5 8.775 19.5 19.5 19.5 19.5-8.775 19.5-19.5" />
    <path fill={theme.palette.common.white} d="m35.615 53.385v-7.2692c0-1.721-1.394-3.116-3.115-3.116-1.7206 0-3.1154 1.3948-3.1154 3.1154v7.2692h-7.2692c-1.721 0.001-3.116 1.395-3.116 3.116 0 1.7206 1.3948 3.1154 3.1154 3.1154h7.2692v7.2692c0.001 1.721 1.395 3.116 3.116 3.116 1.7206 0 3.1154-1.3948 3.1154-3.1154v-7.2692h7.2692c1.721-0.001 3.116-1.395 3.116-3.116s-1.395-3.115-3.115-3.115h-7.2692z" />
  </SvgIcon>
);

IconOrdersAdd.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        150: PropTypes.string.isRequired,
        500: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconOrdersAdd);



// WEBPACK FOOTER //
// ./src/components/icons/IconOrdersAdd.js